module.exports = __webpack_public_path__ + "static/media/1-5-v-chrame-nalezla.3774337f.jpg";